module.exports = __webpack_public_path__ + "static/img/m_name.d338b96.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/wxsjglm/m_name.png
// module id = xzw6
// module chunks = 7